/**
 * The way the template should be processed to gain the template string for use
 * in this particular UI situation. For more detailed information, please
 * consult the integration guide.
 *
 * @public
 */
export enum TemplateType {
	/**
	 * A function, which, when executed will return the template string
	 */
	Function = 'function',
	/**
	 * No template has been specified for this template name
	 */
	Null = 'null',
	/**
	 * A promise, which, when resolves will return the template string.
	 */
	Promise = 'promise',
	/**
	 * The template string to use
	 */
	String = 'string',
	/**
	 * A URL to retrieve the template string from
	 */
	Url = 'url',
}

/**
 * The pro-processor to run the template string through before writing it to the
 * DOM. Please check the integration documents or the `Templates` documentation
 * for information on which properties will be passed in for processors to use,
 * and guidelines for defining templates. All pre-processors will be provided
 * with the same data unless otherwise stated.
 *
 * @public
 */
export enum PreProcessor {
	/**
	 * Don't perform any pre-processing on the template string before writing it
	 * to the DOM.
	 */
	None = 'none',
	/**
	 * Run the template string through the mustache HTML pre-processor before
	 * writing it to the DOM. Find out more information about Mustache templates
	 * here: https://github.com/janl/mustache.js.
	 */
	Mustache = 'mustache'
}
